import { kLinkPrivacyPolicyUrl, kLinkTermsOfServiceUrl } from '@/constants/constants-links'
import { Link } from '@/components/link/Link'
import { kPaxtonName } from '@/constants/constants-strings'

export const PaxtonDisclaimer = () => (
  <p>
    {kPaxtonName} provides self-help services at your specific direction. We are not a law firm or a substitute for an attorney or law firm. Communications
    between you and {kPaxtonName} are protected by our{' '}
    <Link href={kLinkPrivacyPolicyUrl} external size="xs">
      Privacy Policy
    </Link>
    , but not by the attorney-client privilege or as work product. We cannot provide any kind of advice, explanation, opinion, or recommendation about possible
    legal rights, remedies, defenses, options, selection of forms, or strategies. Your access to our website is subject to our{' '}
    <Link href={kLinkTermsOfServiceUrl} external size="xs">
      Terms of Service
    </Link>
    .
  </p>
)
